import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import router from '../router'
import jwt_decode from 'jwt-decode';
import { email } from 'vuelidate/lib/validators';
import * as sessionModel from '@/services/sessionModel';


Vue.use(Vuex)
const defaultState = () => ({
    token: null,
    primerlogin: 0,
    emailAuth: '',
    // Hidratacion desde sessionStorage para que el contador sobreviva reloads:
    // impide que un atacante burle el captcha recargando la pagina cada 3 intentos.
    errores: Number(sessionStorage.getItem('erroresLogin')) || 0,
    // Prendido cuando el backend rechaza un intento de login con
    // errorCode CAPTCHA_REQUIRED (contador server-side >= 3). Se limpia
    // en un login exitoso y en el 409 SESSION_ALREADY_ACTIVE (para no
    // re-pedir captcha en el reintento "forzar", donde el contador
    // server-side ya se reseteo); se mantiene en cualquier otro error para
    // no ocultar el widget de captcha prematuramente (over-mostrar es la
    // direccion segura ante un posible desync con el contador local).
    flagCaptchaRequerido: false,
    // Bandera propia del ingreso, separada del loading general. El loading lo
    // prenden y apagan muchas acciones (getUser entre ellas), asi que entre que
    // una lo apaga y la siguiente lo vuelve a prender queda un instante en el
    // que Vue alcanza a renderizar el login. Esta no la toca nadie mas: se
    // enciende al empezar el login y se apaga recien cuando la navegacion al
    // Dashboard quedo confirmada.
    ingresando: false,
    nroafi: '',
    user: {
        nroafi: '',
        pmaid: '',
        nombres: '',
        apellido: '',
        sexo: '',
        fecnacim: '',
        tipdoc: '',
        nrodoc: '',
        cuil: '',
        emaildistrito: '',
        fecestadocivil: '',
        estadocivil: '',
        nacionalidad: '',
        tipnacionalidad: '',
        fotocarnet: '',
        fecafiliacion: '',
        esjubilado: '',
        esactivo: '',
        resolusionjubilado: '',
        estadodesde: '',
        vencimientocredencialactivo: '',
        tienedeuda: 0,
    },
    afiliado: {
        nroafi: '',
        nombres: '',
        apellido: '',
        sexo: '',
        fecnacim: '',
        tipdoc: '',
        nrodoc: '',
        cuil: '',
        fecestadocivil: '',
        estadocivil: '',
        nacionalidad: '',
        tipnacionalidad: '',
        desnacionalidad: '',
        desestadocivil: '',
        destipnacionalidad: '',
        fotocarnet: '',
    },
    loadSkeleton: false,
    actLogout: false,
    propCredencial: null,
    // Bandera global de modo visor (operador "viendo como" un afiliado).
    // Se setea desde gestion/entrarComoAfiliado y la consultan las vistas
    // para bloquear acciones de escritura. La validacion final vive en el
    // backend. Se rehidrata desde sessionStorage para sobrevivir el refresh.
    esModoGestion: sessionStorage.getItem('esModoGestion') === '1',
});

export default ({
    namespaced: true,

    state: defaultState(),
    /* {
        token: null,
        primerlogin: 0,
        emailAuth: '',
        errores: 0,
        nroafi: '',
        user: {
            nroafi: '',
            pmaid: '',
            nombres: '',
            apellido: '',
            sexo: '',
            fecnacim: '',
            tipdoc: '',
            nrodoc: '',
            cuil: '',
            fecestadocivil: '',
            estadocivil: '',
            nacionalidad: '',
            tipnacionalidad: '',
            fotocarnet: '',
            fecafiliacion: '',
            esjubilado: '',
            esactivo: '',
            resolusionjubilado: '',
            estadodesde: '',
            vencimientocredencialactivo: '',
            tienedeuda: 0, // valor por defecto
        },
        afiliado: {
            nroafi: '',
            //pmaid: '',
            nombres: '',
            apellido: '',
            sexo: '',
            fecnacim: '',
            tipdoc: '',
            nrodoc: '',
            cuil: '',
            fecestadocivil: '',
            estadocivil: '',
            nacionalidad: '',
            tipnacionalidad: '',
            desnacionalidad: '',
            desestadocivil: '',
            destipnacionalidad: '', // interno
            fotocarnet: '',
        },
        loadSkeleton: false 
    },
    */
    getters: {
        emaildistrito(state) {
            return state.user.emaildistrito
        },
        // getters para solicitud de datos en el primer ingreso
        pedirFoto(state) {
            return state.user.pedirFoto
        },
        pedirDatosContacto(state) {
            return state.user.debeActualizarDatosContacto
        },
        //

        email(state) {
            return state.user.email
        },
        tienedeuda(state) {
            return state.user.tienedeuda
        },
        distrito(state) {
            return state.user.distrito
        },
        propCredencial(state) {
            return state.propCredencial
        },
        afiliado(state) {
            return state.afiliado
        },
        getCantidadErroresLogin(state) {
            return state.errores
        },
        flagCaptchaRequerido(state) {
            return state.flagCaptchaRequerido
        },
        user(state) {
            return state.user
        },
        primerlogin(state) {
            return state.primerlogin
        },
        isAuthenticated(state) {
            return (state.token !== null)
        },
        ingresando(state) {
            return state.ingresando
        },
        token(state) {
            return state.token
        },
        getToken(state) {
            return state.token
        },
        emailAuth(state) {
            return state.emailAuth
        },
        nroafi(state) {
            return state.nroafi
        },
        actLogout(state) {
            return state.actLogout
        },
        esJubilado(state) {
            return (state.user.esjubilado)
        },
        esActivo(state) {
            return (state.user.esactivo)
        },
        loadSkeleton(state) {
            return state.loadSkeleton
        },
        esModoGestion(state) {
            return state.esModoGestion
        },
        tiempoRestante: (state, getters) => () => {
            const caducaRaw = sessionStorage.getItem('caduca');
            if (!caducaRaw || isNaN(Number(caducaRaw))) return -1; // Retorna -1 si no hay tiempo de expiración válido
            let ahora = new Date();
            let caduca = new Date(sessionStorage.getItem('caduca') * 1000);
            if (isNaN(caduca.getTime())) return -1; // Retorna -1 si la fecha de caducidad no es válida
            let diferencia = caduca.getTime() - ahora.getTime();
            let minutosFaltan = Math.round(diferencia / 60000);
            return minutosFaltan > 0 ? minutosFaltan : 0
            // return (diferencia)
        },
    },
    mutations: {
        RESET_STATE(state) {
            Object.assign(state, defaultState());
        },
        setAfiliado(state, payload) {
            state.afiliado.nroafi = payload.nroafi
            state.afiliado.nombres = payload.nombres
            state.afiliado.apellido = payload.apellido
            state.afiliado.sexo = payload.sexo
            state.afiliado.fecnacim = payload.fecnacim
            state.afiliado.tipdoc = payload.tipdoc
            state.afiliado.nrodoc = payload.nrodoc
            state.afiliado.cuil = payload.cuil
            state.afiliado.fecestadocivil = payload.fecestadocivil
            state.afiliado.estadocivil = payload.estadocivil
            state.afiliado.nacionalidad = payload.nacionalidad
            state.afiliado.tipnacionalidad = payload.tiponacionalidad
            state.afiliado.fotocarnet = payload.fotocarnet
        },
        setToken(state, token) {
            sessionStorage.setItem('token', token)
            state.token = token
        },
        setLogout(state, payload) {
            state.actLogout = payload
        },
        setUser(state, user) {
            state.user = user
        },
        setCredencial(state, payload) {
            state.propCredencial = payload
        },
        setEmailAuth(state, emailAuth) {
            state.emailAuth = emailAuth
        },
        setNroAfi(state, nroafi) {
            state.nroafi = nroafi
        },
        setLoadingSkeleton(state, payload) {
            state.loadSkeleton = payload
        },
        setCantidadErroresLogin(state, payload) {
            state.errores = (payload == 0) ? 0 : state.errores + 1
            // Write-through a sessionStorage para que el contador sobreviva reloads.
            // resetAuth limpia via sessionStorage.clear() — no hace falta remove explicito.
            sessionStorage.setItem('erroresLogin', String(state.errores))
        },
        setFlagCaptchaRequerido(state, payload) {
            state.flagCaptchaRequerido = !!payload
        },
        setIngresando(state, payload) {
            state.ingresando = !!payload
        },
        setPrimerLogin(state, payload) {
            state.primerLogin = payload
        },
        setEsModoGestion(state, payload) {
            state.esModoGestion = !!payload
            if (payload) sessionStorage.setItem('esModoGestion', '1')
            else sessionStorage.removeItem('esModoGestion')
        },
    },
    actions: {
        // Fuente unica de verdad de la destruccion de sesion Y de los resets
        // de modulos Vuex del logout de afiliado. Ramifica sobre el contexto:
        // con contexto de operador activo, solo borra la sesion del afiliado
        // (preserva gestion_*); sin contexto de operador, blanket clear via
        // sessionModel (unico lugar legal de sessionStorage.clear()).
        // TODOS los resets de modulos viven aca (incluido mediosDePago, antes
        // duplicado solo en cerrarSesion): degradarSesion() delega en esta
        // accion para el caso normal, y un afiliado ordinario que degrada via
        // getUser/decodeToken no debe quedar con mediosDePago stale.
        resetAuth({ commit, dispatch }) {
            if (sessionModel.hayContextoOperador()) {
                sessionModel.clearAffiliateSession();
            } else {
                sessionModel.clearAllSession();
            }
            dispatch('resetRootState', null, { root: true });
            dispatch('dataUser/resetDataUser', null, { root: true });
            dispatch('boletas/resetModulo', null, { root: true });
            dispatch('mediosDePago/resetModulo', null, { root: true });
            commit('RESET_STATE');
        },
        // Punto unico de degradacion de sesion, reutilizado por el catch de
        // getUser, decodeToken (token vacio) y cerrarSesion. Nunca renderiza
        // el login de afiliados bajo contexto de operador.
        degradarSesion({ dispatch }) {
            if (sessionModel.esFrame()) {
                // Dentro del iframe: avisar al padre para que cierre la vista
                // y vuelva al form de busqueda del operador. Abortamos: no
                // seguimos ejecutando ninguna otra rama.
                window.parent.postMessage({ type: 'gestion-cerrar-sesion' }, window.location.origin)
                return;
            }
            if (sessionModel.hayContextoOperador()) {
                // Ventana externa del operador: NUNCA al login de afiliados.
                // Volvemos a la busqueda de gestion; no tocamos gestion_*.
                dispatch('notificaciones/showSnack', {
                    message: 'Tu sesión de gestión venció. Reingresá desde SICA.',
                    type: '400',
                }, { root: true })
                router.push('/gestionPortal').catch(() => { })
                return;
            }
            // Normal: SIEMPRE delegar en resetAuth (nunca clearAffiliateSession
            // ni clear inline por su cuenta).
            dispatch('resetAuth').then(() => {
                router.push('/login').catch(() => { })
            })
        },
        refreshToken({ commit, dispatch }, fn) {
            axios({
                method: 'post',
                url: process.env.VUE_APP_API + 'refreshToken',
                withCredentials: false,
                data: { nroafi: sessionStorage.getItem('nroafi') },
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + sessionStorage.getItem('token')
                }
            })
                .then(function (response) {
                    const res = response.data.message
                    dispatch('decodeToken', res['Authorization'])
                    // esto se ejecuta en el callback de la llamada
                    if (typeof (fn) === 'function')
                        fn(res)
                })
                .catch(function (error) {
                    console.log(error.data)
                    commit('setToken', null)
                });
        },
        //revisar
        async getUser({ commit, dispatch, state }, obj) {
            dispatch('auth/setSktLoader', true, { root: true })
            let result = false;
            await axios({
                method: 'post',
                url: process.env.VUE_APP_API + 'portal/afiliado/obtenerAfiliado',
                withCredentials: false,
                data: JSON.stringify(obj),
                headers: {
                    "Content-Type": "application/json",
                }
            })
                .then(function (response) {
                    const res = response.data.message
                    if (res.error == 2) {
                        // En modo gestion estamos dentro del iframe: no mostramos
                        // el mensaje aca, le avisamos al padre para que cierre el
                        // iframe y vuelva al form de busqueda mostrando el msg.
                        const esModoGestion = (() => {
                            try {
                                const t = sessionStorage.getItem('token')
                                return !!t && jwt_decode(t).mode === 'gestion'
                            } catch (e) { return false }
                        })()
                        if (esModoGestion && sessionModel.esFrame()) {
                            // En gestion NO mostramos res.msg: ese texto esta pensado
                            // para el afiliado (ej. "comunicate con tu Delegacion"), no
                            // para el operador. Mostramos un mensaje propio que contempla
                            // tanto que el afiliado no exista como que no corresponda a
                            // la delegacion del operador (el back no distingue ambos casos).
                            window.parent.postMessage({
                                type: 'gestion-afiliado-no-encontrado',
                                msg: 'No se encontró un afiliado/a con esos datos, o no corresponde a tu delegación.'
                            }, window.location.origin)
                        } else {
                            dispatch('notificaciones/showSnack', {
                                message: res.msg,
                                type: "400",
                            }, { root: true })
                        }
                        result = false;
                    } else {
                        commit('setUser', res)
                        commit('setAfiliado', res)
                        const estados = { esactivo: res.esactivo, esjubilado: res.esjubilado, esesb: res.esesb }
                        dispatch('navigations/fetchItems', estados, { root: true })
                        dispatch('dataUser/setFotoCarnetAfiliado', res.fotocarnet, { root: true })
                        dispatch('dataUser/setFotoPerfilAfiliado', res.fotoperfil, { root: true })
                        sessionStorage.setItem('user', JSON.stringify(res))
                        sessionStorage.setItem('distrito', JSON.stringify(res.distrito))
                        result = true;
                    }
                })
                .catch(function (error) {
                    console.log(error)
                    dispatch('degradarSesion')
                }).finally(() => {
                    // Unico apagado del loading. Antes se despachaba tambien en
                    // la rama de error y al final del then: el finally corre
                    // siempre y despues que los dos, asi que eran redundantes.
                    dispatch('notificaciones/stopLoading', null, { root: true })
                    dispatch('auth/setSktLoader', false, { root: true })
                });
            return result;
        },
        async validarImagen({ commit, dispatch }, obj) {
            try {
                const response = await axios({
                    method: 'post',
                    url: process.env.VUE_APP_API + 'validarImagen',
                    withCredentials: false,
                    data: obj,
                    headers: {
                        "Content-Type": "multipart/form-data",
                    }
                });
                const res = response.data;
                if (!res.success) {
                    dispatch('notificaciones/showSnack', {
                        message: res.message,
                        type: "400",
                    }, { root: true });
                    return false; // Imagen no válida
                }
                return true; // Imagen válida
            } catch (error) {
                console.error("Error al validar la imagen:", error);
                return false; // En caso de error, considerar la imagen no válida
            } finally {
                dispatch('notificaciones/stopLoading', null, { root: true });
            }
        },
        async login({ commit, dispatch, state }, obj) {
            const payload = { nroafi: obj.nroafi, password: obj.password, captcha: obj.captcha }
            if (obj.forzar) payload.forzar = true
            await axios({
                method: 'post',
                url: process.env.VUE_APP_API + 'login',
                withCredentials: false,
                data: JSON.stringify(payload),
                headers: {
                    "Content-Type": "application/json",
                }
            }).then((response) => {
                // Se enciende recien con las credenciales ya validadas, en el
                // mismo callback sincrono que setea el token: desde aca hasta
                // que cambia la ruta no hay un solo instante destapado.
                // Antes de la request no va, porque un login fallido no merece
                // un overlay a pantalla completa: le alcanza el boton girando.
                commit('setIngresando', true)

                const res = response.data.message
                const token = res['Authorization']
                dispatch('decodeToken', token)
                dispatch('notificaciones/startLoading', null, { root: true })
                // Estos commits son sincronos y no dependen de getUser. Van
                // antes del return porque despues quedarian inalcanzables.
                commit('setPrimerLogin', res.primerlogin)
                commit('setCantidadErroresLogin', 0)
                commit('setFlagCaptchaRequerido', false)

                // El return no es decorativo: sin el, esta promesa no la espera
                // nadie y la accion login resuelve apenas contesta /login. El
                // form daba por terminado el ingreso ahi mismo, apagaba el
                // cargando y vaciaba los campos mientras getUser seguia en
                // vuelo, asi que el usuario veia el login vacio y creia que
                // tenia que entrar de nuevo. Devolviendola, login no termina
                // hasta que getUser respondio y la navegacion arranco.
                return dispatch('getUser', { nroafi: state.nroafi, bit: 0 }).then((result) => {
                    if (!result) {
                        dispatch('cerrarSesion')
                        return
                    }

                    // Se devuelve la navegacion para que la accion no termine
                    // antes de tiempo: router.push resuelve una vez pasados los
                    // guards, o sea cuando el Dashboard ya es la ruta activa.
                    return router.push('/dashboard').catch(() => { })
                })
            }).catch(function (error) {
                if (error.response?.status === 409 && error.response.data?.errorCode === 'SESSION_ALREADY_ACTIVE') {
                    // Un 409 SESSION_ALREADY_ACTIVE solo ocurre DESPUES de que el
                    // backend valido las credenciales y reseteo su contador de
                    // fallos (ver Login::login, paso 7 vs 8). El front debe
                    // reflejar el mismo reset (contador Y flag) para que el
                    // forzar-retry no vuelva a exigir captcha (regresion AD-10).
                    commit('setCantidadErroresLogin', 0)
                    commit('setFlagCaptchaRequerido', false)
                    return Promise.reject(error)
                }
                if (error.response?.data?.errorCode === 'CAPTCHA_REQUIRED') {
                    // El backend rechazo por captcha faltante/invalido/expirado
                    // ANTES de intentar autenticar: no cuenta como un fallo de
                    // credencial, no incrementamos el contador local.
                    commit('setFlagCaptchaRequerido', true)
                    dispatch('notificaciones/showSnack', {
                        message: error.response.data.message,
                        type: "400",
                    }, { root: true })
                    dispatch('notificaciones/stopLoading', null, { root: true })
                    return Promise.reject(error)
                }
                commit('setCantidadErroresLogin', 1)
                dispatch('notificaciones/showSnack', {
                    message: error.response.data.message,
                    type: "400",
                }, { root: true })
                dispatch('notificaciones/stopLoading', null, { root: true })
            }).finally(() => {
                // Unico punto de apagado, y cubre exito y error por igual.
                // Corre despues de toda la cadena porque el then devuelve la
                // promesa de getUser encadenada con la navegacion.
                commit('setIngresando', false)
            })
        },
        async cerrarSesion({ commit, dispatch }) {
            // Si estamos adentro del iframe del modo gestion, en vez de
            // redirigir a /login (que renderizaria el login adentro del
            // iframe), avisamos al padre por postMessage para que cierre la
            // vista del iframe y vuelva al form de busqueda. Deteccion via
            // sessionModel: el marcador gestion_sid (sesion de operador)
            // sobrevive aunque el token del afiliado ya se haya limpiado
            // (p.ej. estando en la pantalla de busqueda). Con esto, en modo
            // gestion NUNCA caemos al login normal de afiliados.
            const enGestion = sessionModel.hayContextoOperador()
            const cerrarVistaGestion = () => {
                if (sessionModel.esFrame()) {
                    // Dentro del iframe del portal: avisar al padre (GestionPortal)
                    // para cerrar la vista y volver al form de busqueda del operador.
                    window.parent.postMessage({ type: 'gestion-cerrar-sesion' }, window.location.origin)
                } else if (enGestion) {
                    // Ventana externa del operador: NUNCA al login de afiliados.
                    // Volvemos a la pantalla de gestion; si la sesion de operador
                    // tambien expiro, el operador reingresa desde SICA.
                    dispatch('notificaciones/showSnack', {
                        message: 'Tu sesión de gestión se cerró. Si necesitás seguir, reingresá desde SICA.',
                        type: '400',
                    }, { root: true })
                    router.push('/gestionPortal').catch(() => { })
                } else {
                    router.push('/login').then(() => { }).catch(() => {
                        location.reload();
                    })
                }
            }

            await axios({
                method: 'post',
                url: process.env.VUE_APP_API + 'logout',
                withCredentials: false,
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + sessionStorage.getItem('token')
                },
                data: JSON.stringify({ nroafi: sessionStorage.getItem('nroafi') })
            }).then((response) => {
                const res = response.data
                if (res.code == 200) {
                    // resetAuth ya hace TODOS los resets de modulos (incluido
                    // mediosDePago): no duplicar el dispatch aca.
                    dispatch('resetAuth');
                    cerrarVistaGestion()
                }
            }).catch(function (error) {
                // Logout del backend fallo (token vencido/invalido, red, etc.).
                // Limpiamos igual el estado local para no dejar sessionStorage
                // con token basura y evitar bucles en el interceptor 403/401.
                dispatch('resetAuth');
                cerrarVistaGestion()
            }).finally(() => {
                dispatch('notificaciones/stopLoading', null, { root: true })
            })
        },
        decodeToken({ commit, dispatch }, token) {
            if (!token) {
                dispatch('degradarSesion')
                return;
            }
            commit('setToken', token)
            // cuando se decodifica token
            // se obtiene nroafi y mail registrado 
            var decoded = jwt_decode(token)
            var arr = decoded.sub.split('*_*')
            //guardo cuando caduca
            sessionStorage.setItem('caduca', decoded.exp)
            //dispatch('getUser', parseInt(arr[0]))
            commit('setNroAfi', parseInt(arr[0]))
            sessionStorage.setItem('nroafi', arr[0])
            commit('setEmailAuth', arr[1])
            sessionStorage.setItem('emailAuth', arr[1])
        },
        /*         cerrarSesion({ commit, dispatch }) {
                    //dispatch('notificaciones/startLoading', null, { root: true })
                    dispatch('logout')
                    dispatch('notificaciones/startLoading', null, { root: true })
                    //dispatch('logout')
                    commit('setToken', null)
                    commit('setEmailAuth', '')
                    commit('setNroAfi', null)
                    commit('setUser', {})
                    sessionStorage.removeItem('caduca')
                    sessionStorage.removeItem('token')
                    sessionStorage.removeItem('user')
                    sessionStorage.removeItem('emailAuth')
                    sessionStorage.removeItem('nroafi')
                    dispatch('notificaciones/stopLoading', null, { root: true })
                    router.go('/login');
                }, */


        // generador de credencial de usuario
        async generarCredencialAfiliado({ commit, dispatch, state }) {
            await axios({
                method: 'post',
                url: process.env.VUE_APP_API + 'portal/credencial/imprimirPDFCredencialActivo',
                withCredentials: false,
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + sessionStorage.getItem('token')
                },
                responseType: "blob",
                data: { nroafi: sessionStorage.getItem('nroafi') }
            }).then((response) => {
                //creo archivo a partir de la respuesta para
                //abrirlo en una nueva pestaña
                const file = new Blob([response.data], {
                    type: "application/pdf",
                });
                const fileURL = URL.createObjectURL(file);
                window.open(fileURL);
            }).catch(function (error) {
                dispatch('notificaciones/showSnack', {
                    message: "No pudo generarse su credencial",
                    type: 400,
                }, { root: true })
            })
        },
        async generarCredencialJubilado({ commit, dispatch, state }) {
            await axios({
                method: 'post',
                url: process.env.VUE_APP_API + 'portal/credencial/imprimirPDFCredencialJubilado',
                withCredentials: false,
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + sessionStorage.getItem('token')
                },
                responseType: "blob",
                data: { nroafi: sessionStorage.getItem('nroafi') }
            }).then((response) => {
                //creo archivo a partir de la respuesta para
                //abrirlo en una nueva pestaña
                const file = new Blob([response.data], {
                    type: "application/pdf",
                });
                const fileURL = URL.createObjectURL(file);
                window.open(fileURL);
            }).catch(function (error) {
                dispatch('notificaciones/showSnack', {
                    message: "No pudo generarse su credencial",
                    type: 400,
                }, { root: true })
            })
        },

        //Constancia convenios
        async generarConstanciaConvenios({ commit, dispatch, state }) {
            await axios({
                method: 'post',
                url: process.env.VUE_APP_API + 'portal/credencial/imprimirPDFConstanciaConvenios',
                withCredentials: false,
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + sessionStorage.getItem('token')
                },
                responseType: "blob",
                data: { nroafi: sessionStorage.getItem('nroafi') }
            }).then((response) => {
                //creo archivo a partir de la respuesta para
                //abrirlo en una nueva pestaña
                const file = new Blob([response.data], {
                    type: "application/pdf",
                });
                const fileURL = URL.createObjectURL(file);
                window.open(fileURL);
            }).catch(function (error) {
                dispatch('notificaciones/showSnack', {
                    message: "No pudo generarse su credencial",
                    type: 400,
                }, { root: true })
            })
        },

        generarCredencial({ commit, dispatch, state }, url) {

            var id = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5);
            var l = Math.floor(Math.random() * 100);
            var t = Math.floor(Math.random() * 100);
            var data = { nroafi: state.nroafi }
            var form = document.createElement("form");
            form.action = url;
            form.method = 'POST';
            form.target = id;
            for (var key in data) {
                var input = document.createElement("textarea");
                input.name = key;
                input.value = typeof data[key] === "object" ? JSON.stringify(data[key]) : data[key];
                form.appendChild(input);
            }
            form.style.display = 'none';
            document.body.appendChild(form);
            window.open('', id, 'scrollbars=no,menubar=no,height=600,width=800,resizable=yes,toolbar=no,status=no,left=' + l + ',top=' + t);
            form.submit();
        },
        setSktLoader({ commit, dispatch }, data) {
            commit('setLoadingSkeleton', data)
        },

        // validadcion de datos de contacto actualizados
        async datosValidos({ dispatch, commit, state }) {
            await axios({
                method: 'post',
                withCredentials: false,
                url: process.env.VUE_APP_API + 'portal/datosValidados',
                data: { djdc_nroafi: state.nroafi, djdc_datos_validados: 1 },
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + sessionStorage.getItem('token')
                }
            }).then((response) => {
                const res = response.data
                if (res.success) {
                    console.log('Datos validados correctamente')
                }
            }).catch(function (error) {
                console.log('Error al validar los datos ' + error)
            }).finally(() => {
                //dispatch('notificaciones/startLoading', null, { root: true })
            })
        }
    },

})